import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterNavigation from './components/ClusterNavigation';
import QuickLeadSection from './components/QuickLeadSection';
import WhatIsTalentPool from './components/WhatIsTalentPool';
import WhyCompanyNeeds from './components/WhyCompanyNeeds';
import WhenNeeded from './components/WhenNeeded';
import WhoToInclude from './components/WhoToInclude';
import HowFormed from './components/HowFormed';
import TalentPoolAndIPR from './components/TalentPoolAndIPR';
import FutureLeaders from './components/FutureLeaders';
import HowDevelopReservist from './components/HowDevelopReservist';
import WhatNotWorks from './components/WhatNotWorks';
import HowEvaluateReadiness from './components/HowEvaluateReadiness';
import CorporateTrainingLink from './components/CorporateTrainingLink';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import WorkFormats from './components/WorkFormats';
import AboutTrainer from './components/AboutTrainer';
import StudyFurtherSection from './components/StudyFurtherSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

const hubNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Этапы', target: 'stages' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function TalentPoolPage() {
  return (
    <>
      
      <SeoTitle title="Кадровый резерв | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />

        <div id="cluster">
          <ClusterNavigation />
        </div>

        <QuickLeadSection />
        <WhatIsTalentPool />

        <div id="tasks">
          <WhyCompanyNeeds />
        </div>

        <WhenNeeded />
        <WhoToInclude />

        <div id="stages">
          <HowFormed />
        </div>

        <TalentPoolAndIPR />
        <FutureLeaders />
        <HowDevelopReservist />
        <WhatNotWorks />
        <HowEvaluateReadiness />
        <CorporateTrainingLink />
        <WhyProgramsWork />
        <CompanyResults />

        <div id="formats">
          <WorkFormats />
        </div>

        <AboutTrainer />
        <LeadMagnetBlock variant="compact" />
        <StudyFurtherSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
}